import { render, staticRenderFns } from "./AllGrinder.vue?vue&type=template&id=0bbfc37e&scoped=true"
import script from "./AllGrinder.vue?vue&type=script&lang=js"
export * from "./AllGrinder.vue?vue&type=script&lang=js"
import style0 from "./AllGrinder.vue?vue&type=style&index=0&id=0bbfc37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbfc37e",
  null
  
)

export default component.exports